import React from 'react'
import { Link } from 'react-router-dom'
import * as CONFIG from './_config'
import ls from "local-storage";

class Pharmacy extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    componentDidMount() {
       ls.set('redirectTo',window.location.href);
    }

    render() {
        var route_Name = 'Download Our Pharmacy Apps'
    return (
        <div className="main-container full-width pt-5 mt-5">

                <section id="apus-breadscrumb" className="breadcrumb-page apus-breadscrumb"
                         style={{backgroundColor: '#f3ffd9'}}>
                    <div className="container">
                        <div className="wrapper-breads">
                            <div className="wrapper-breads-inner">
                                <div className="breadscrumb-inner text-center">
                                    <h2 className="bread-title">{route_Name}</h2>
                                    <ol className="breadcrumb ml-5 ">
                                        <li><a href="/">Home</a></li>
                                        <li><span className="active">{route_Name}</span></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


            <section id="main-container" className="container inner">
                <div className="row">
                    <div id="main-content" className="main-page col-xs-12 col-md-12 clearfix">
                        <main id="main" className="site-main" role="main">
                            <div>
                                <div className="elementor-inner">
                                    <div className="elementor-section-wrap">
                                        <section className="elementor-element elementor-element-22e27678 elementor-section-boxed elementor-section-height-default elementor-section-height-default elementor-section elementor-top-section">
                                            <div
                                                className="elementor-container elementor-column-gap-default theme-2 ">
                                                <div className="row">
                                                    <div className="col-md-12 text-center" style={{textAlign: 'center'}}>
                                                        <div className="elementor-element elementor-element-2acbe3ea elementor-column elementor-col-33 elementor-top-column">
                                                            <div
                                                                className="elementor-column-wrap  elementor-element-populated">
                                                                <div className="elementor-widget-wrap">
                                                                    <div className="elementor-element elementor-element-7b3657ed elementor-widget elementor-widget-image">
                                                                        <div className="elementor-widget-container">
                                                                            <div className="elementor-image">
                                                                                <img
                                                                                    width={500}
                                                                                    src="/assets/images/pruetts-pharmacy.png"
                                                                                    className="attachment-large size-large"
                                                                                    alt="pharmacy download apps"
                                                                                    style={{textAlign: 'center'}}
                                                                                />{" "}
                                                                                <br />
                                                                                <br />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <section className="elementor-element elementor-element-12f7999 elementor-section-boxed elementor-section-height-default elementor-section-height-default elementor-section elementor-inner-section" >
                                                                        <div className="elementor-container elementor-column-gap-default">
                                                                            <div className="elementor-row">
                                                                                <div className="elementor-element elementor-element-61fe5fb elementor-column elementor-col-50 elementor-inner-column">
                                                                                    <div className="elementor-column-wrap  elementor-element-populated">
                                                                                        <div className="elementor-widget-wrap">
                                                                                            <div className="elementor-element">
                                                                                                <div className="elementor-widget-container">
                                                                                                    <div className="elementor-image">
                                                                                                        <a href="https://play.google.com/store/apps/details?id=net.winrx.pruetts" target="_blank"  className="d-inline"
                                                                                                           title="Download from Google Play"
                                                                                                        >
                                                                                                            <img
                                                                                                                src="/assets/images/google_play_large.png"
                                                                                                                alt="download from google play"
                                                                                                                width="400px"
                                                                                                            />
                                                                                                        </a>

                                                                                                        <a href="https://apps.apple.com/us/app/pruetts-rx/id1502469379" target="_blank" className="d-inline"
                                                                                                           title="Download from App Store"
                                                                                                        >
                                                                                                            <img
                                                                                                                src="/assets/images/app_store_large.png"
                                                                                                                alt="download from app store"
                                                                                                                width="400px"
                                                                                                            />
                                                                                                        </a>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <br /><br /><br />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                
                                                                            </div>
                                                                        </div>
                                                                    </section>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                        
                                    </div>
                                </div>
                            </div>
                        </main>
                        {/* .site-main */}
                    </div>
                    {/* .content-area */}
                </div>
            </section>
        </div>

    )
    }
}
export default Pharmacy;



